import { defineMessages } from 'react-intl';

export const priceDiscountMessages = defineMessages({
  originalPrice: {
    id: 'price.aria.originalPrice.label',
    defaultMessage: 'Ursprünglicher Preis',
  },
  discount: {
    id: 'price.aria.discount.label',
    defaultMessage: 'Rabatt',
  },
});
